import { ProcessedApplicant } from "../applicantsTable/customTypes"


export function generateCSV(
  applicants: ProcessedApplicant[],
  showOnlyQualified: boolean,
  hiringCampaignId: string,
): string {
  const headers = [
    "ID",
    "First Name",
    "Last Name",
    "Company Name",
    "Position",
    "Email",
    "Is Qualified",
    "Category",
    "Note",
    "Is Hidden",
    "Resume URL",
    "Hiring Campaign ID",
  ]

  const csvContent = [
    headers.join(","),
    ...applicants
      .map((applicant) => {
        if (!applicant.qualified && showOnlyQualified) return null
        return [
          applicant._id,
          applicant.firstName,
          applicant.lastName,
          applicant.companyName || "",
          applicant.position || "",
          applicant.email,
          applicant.qualified,
          applicant.category,
          `"${applicant.note.replace(/"/g, '""')}"`, // Escape quotes in notes
          applicant.isHidden,
          applicant.resumeUrl,
          hiringCampaignId,
        ].join(",")
      })
      .filter(Boolean),
  ].join("\n")

  return csvContent
}

export function downloadCSV(csvContent: string, filename = "applicants.csv"): void {
  const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" })
  const link = document.createElement("a")
  if (link.download !== undefined) {
    const url = URL.createObjectURL(blob)
    link.setAttribute("href", url)
    link.setAttribute("download", filename)
    link.style.visibility = "hidden"
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
  }
}
